import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TableRowSelectEvent } from 'primeng/table';
import { Subject, take, takeUntil } from 'rxjs';
import { LocationService } from 'src/app/services/location.service';
import { AppConstants } from 'src/app/shared/app.constants';
import { AddressCandidate, AddressSuggestion, Candidate, Suggestion } from 'src/app/shared/models/location-models';

@Component({
  selector: 'ness-verify-location',
  templateUrl: './verify-location.component.html'
})
export class VerifyLocationComponent implements OnInit {
  addressCandidates: Candidate[] = [];
  cols: any[] = [
    { field: 'address', header: 'Address' },
    { field: 'attributes', subfield: 'Addr_type', header: 'Location type' },
    { field: 'score', header: 'Confidence score' }
  ];
  locationVerifyForm: FormGroup;
  @Output() onAddressVerified = new EventEmitter<Candidate>();
  rows: number = AppConstants.defaultTableRows;
  private _unsubscribe$: Subject<void> = new Subject<void>();
  addressSuggestions: Suggestion[] = [];

  private _locationToSearch: string;
  @Input() set locationToSearch(search: string) {
    this._locationToSearch = search;
  }
  get locationToSearch(): string {
    return this._locationToSearch;
  }

  public _defaultlocation: Suggestion = null;

  constructor(
    private fb: FormBuilder,
    private locationService: LocationService,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.locationVerifyForm = this.fb.group({
      Address: ['', Validators.required]
    });

    if (!!this.locationToSearch) {
      this._defaultlocation = {
        text: this.locationToSearch
      } as Suggestion;
    }
  }
  public clearAllFields(): void {
    this.locationVerifyForm.patchValue({
      Address: ''
    });
    this.locationToSearch = null;
    this.addressCandidates = [];
    this.changeDetectorRef.detectChanges();
  }

  public onRowSelected(event: TableRowSelectEvent): void {
    this.onAddressVerified.emit(event.data);
  }

  public onVerifyAddressSubmit(): void {
    let addressObj = this.locationVerifyForm.get('Address').value;
    if (this.locationVerifyForm.valid) {
      let streetAddress = addressObj.text ? addressObj.text : addressObj;
      let magicKey = addressObj.magicKey ? addressObj.magicKey : "";
      this.locationToSearch = null;
      this.locationService.findAddressCandidates(streetAddress, magicKey).pipe(take(1)).subscribe(
        (data:string) => {
          let results = JSON.parse(data) as AddressCandidate;
          this.addressCandidates = [...results.candidates];
          this.changeDetectorRef.detectChanges();
        },
      );
    }
  }

  public getAddressSuggestions(evt: {originalEvent:Event, query:string}): void {
    if (evt.query) {
      this.locationService.findAddressSuggestions(evt.query.toLowerCase()).pipe(takeUntil(this._unsubscribe$)).subscribe(
        (data:string) => {
          let results = JSON.parse(data) as AddressSuggestion;
          this.addressSuggestions = results["suggestions"]
          this.changeDetectorRef.detectChanges();
        }
      );
    }
  }

}
